import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { useCurrencyStore } from '../../zustand/useCurrencyStore';
import { useGameStatsStore } from '../../zustand/useGameStatsStore';

export const farmerReducer = (scratch: StatsSnapshot) => {
  const farmer = scratch.generators.farmer;

  // Only update if ticksCount is a multiple of ticksToGenerate
  const ticksToGenerate = farmer.ticksToGenerate ?? 1;
  if (useGameStatsStore.getState().getActiveTicksCount() % ticksToGenerate !== 0) {
    return;
  }

  const foodGenerated = farmer.owned * farmer.baseGeneration;

  // Apply upgrades somehow, somewhere...

  useCurrencyStore.getState().addFood(foodGenerated);

  return;
};
